import { Box, Skeleton, Stack, styled } from '@mui/material';

export const CategorySelectorWrapper = styled(Box)`
  legend {
    display: none;
  }
`;

export const CategorySelectorPlaceholder = () => {
  return (
    <CategorySelectorWrapper>
      <Stack
        gap={1}
        sx={{
          display: {
            xs: 'none',
            md: 'flex',
          },
        }}
      >
        {Array.from({ length: 10 }).map((_, index) => (
          <Skeleton variant='rounded' key={index} height={30} />
        ))}
      </Stack>
    </CategorySelectorWrapper>
  );
};
